import React from "react";

import { GridWrapper, GridItem } from "@sainsburys-tech/luna-grid";

import {
  MobileNumberInputField,
  NameInputField,
  SelectInputField,
} from "@jsainsburyplc/id-ui-common";

import {
  TITLE,
  FIRST_NAME,
  LAST_NAME,
  LAST_NAME_REQUIRED,
  LAST_NAME_INVALID,
  FIRST_NAME_REQUIRED,
  FIRST_NAME_INVALID,
  MOBILE_NUMBER,
  NUMBER_INVALID,
} from "constants/registrationForm";
import { TITLES } from "constants/titles";

import SectionContainer from "./SectionContainer";

const MyDetails = ({ myDetailsData: { label, elements }, userEmail }) => (
  <SectionContainer label={label}>
    <div className="ln-c-form-group">
      <div className="ln-c-label">Email address</div>
      <div aria-labelledby="existing email" style={{ wordWrap: "break-word" }}>
        {userEmail}
      </div>
    </div>
    <GridWrapper>
      <GridItem size={{ sm: "1/2" }}>
        <div className="ln-c-form-group">
          {elements[TITLE] && (
            <SelectInputField
              name={TITLE}
              label="Title (optional)"
              options={TITLES}
            />
          )}
        </div>
      </GridItem>
    </GridWrapper>
    <GridWrapper>
      <GridItem size={{ sm: "1/2" }}>
        <div className="ln-c-form-group">
          {elements[FIRST_NAME] && (
            <NameInputField
              name={FIRST_NAME}
              label="First name"
              requiredValidationMessage={FIRST_NAME_REQUIRED}
              validationMessage={FIRST_NAME_INVALID}
            />
          )}
        </div>
      </GridItem>
      <GridItem size={{ sm: "1/2" }}>
        <div className="ln-c-form-group">
          {elements[LAST_NAME] && (
            <NameInputField
              label="Last name"
              name={LAST_NAME}
              requiredValidationMessage={LAST_NAME_REQUIRED}
              validationMessage={LAST_NAME_INVALID}
            />
          )}
        </div>
      </GridItem>
    </GridWrapper>
    <div className="ln-c-form-group">
      {elements[MOBILE_NUMBER] && (
        <MobileNumberInputField
          data-testid="mobile-number"
          name={MOBILE_NUMBER}
          label="Mobile number"
          info="We'll use this to contact you about order updates and for security purposes."
          placeholder=""
          validationMessage={NUMBER_INVALID}
          autoComplete="tel"
        />
      )}
    </div>
  </SectionContainer>
);

export default MyDetails;
